var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDrown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 0.166708L0 1.33337L5 6.33337L10 1.33337L8.83333 0.166708L5 4.00004L1.16667 0.166708Z",
    fill: "#2B2B2B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDrown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowDrown.49dcbaf977c78ee00d7cb6cf3093cb2e.svg";